import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useDataAggregation } from '../../Common/hooks/useAggregationData';
import { useIgdChartsDataContext } from './hooks/useIgdChartsDataContext';
import { getMonthLabel } from '../../../Common/Util/getMonthLabel'

export const RegistrationUpdatesMonthly = () => {
    const { chartData } = useIgdChartsDataContext();

    const rawData = chartData?.registrationUpdatesMonth || [];

    const formattedValues = rawData.map((item) => {
        const value = Number(item.value);
        return isNaN(value) ? 0 : Number(value.toFixed(2));
    });

    const isYearComparison = rawData.length > 0 && rawData.every(item => item.mes === rawData[0].mes);
    const formattedSubtitles = isYearComparison ? rawData.map(item => `${getMonthLabel(item.mes)}/${item.ano}`): rawData.map(item => getMonthLabel(item.mes));

    return (
        <SimpleBars
            title={'Taxa de Atualização Cadastral (Mensal)'}
            horizontal={false}
            subtitles={formattedSubtitles}
            values={formattedValues}
        />
    );
};